export default "__VITE_ASSET__FsPCmaVC__"